import { UID } from '@saliente/library';
import { Exclude, Type } from 'class-transformer';
import { Subject, Subscription } from 'rxjs';

export class MeasureUnitModel {
	public id: number;
	public shortName: string;
	public description: string;
	public isAdvanced: boolean;
	public shortNameEn: string;
	public descriptionEn: string;
	public unCode: string;
	public displayOrder: number;

	static typeProvider() {
		return MeasureUnitModel;
	}
}

export class CpvCodeModel {
	public id: number;
	public code: string;
	public description: string;
	public codeEn: string;
	public descriptionEn: string;
	public displayOrder: number;

	static typeProvider() {
		return CpvCodeModel;
	}
}

export type CodeType = 'cpv' | 'nc';

// state of a CPV / NC combobox list: filtered on the server and loaded page by page
export class CodeListState {
	public data: any[] = [];
	public filter: string = '';
	public hasMore: boolean = false;
	public loading: boolean = false; // not bound to the combobox: its loading state resizes the controls and makes the screen flicker
	public loadedCount: number = 0; // rows received from the server for the current filter (next page offset)
	public filterSubject = new Subject<string>();
	public filterSubscription: Subscription;
	public loadSubscription: Subscription;
	public scrollElement: HTMLElement;
	public scrollListener: (event: Event) => void;
}

export class NcCodeModel {
	public id: number;
	public code: string;
	public description: string;
	public isEFactura: boolean;
	public codeEn: string;
	public descriptionEn: string;
	public displayOrder: number;

	static typeProvider() {
		return NcCodeModel;
	}
}

export class ItemListModel {
	public recordsCount: number;
	public first: number;
	public last: number;
	public pageSize: number;
	public data: ItemModel[]
}

export class ItemModel {
	public externalId: string = UID();;
	public clientEid: string;
	public name: string;
	public currencyCode: string;
	public lastPrice: number;
	public measureUnitId: number;
	public isActive: boolean = true;
	public hasExcise: boolean;
	public exciseFormula: string;
	public exciseValue: number;
	public cpvCodeId: number;
	public ncCodeId: number;
	public categoryExternalId: string;
	public categoryName: string;
	public categoryRevenueAccount: string;
	public categoryDetails: string;
	public categoryHasVat: boolean = true;
	public categoryType: string = 'SIMPLE';
	public categoryExpenseAccount: string;
	public categoryStockAccount: string;
	public itemCode: string;
	public isStockable: boolean;

	@Exclude()
	public displayName: string;
	
	@Type(MeasureUnitModel.typeProvider)
	public measureUnit: MeasureUnitModel;

	@Type(CpvCodeModel.typeProvider)
	public cpvCode: CpvCodeModel;

	@Type(NcCodeModel.typeProvider)
	public ncCode: NcCodeModel;

	static typeProvider() {
		return ItemModel;
	}
}

export class ItemModelLite {
	public externalId: string = UID();;
	public clientEid: string;
	public name: string;
	public isActive: boolean = true;
	public itemCode: string;

	static typeProvider() {
		return ItemModelLite;
	}
}

